import axios from 'axios'

function getLocales(lang) {
    var localesFile = 'config/locales/' + lang + '/locales.json'
    return axios.get(localesFile)
}

function getPages(lang) {
    var localesFile = 'config/locales/' + lang + '/pages.json'
    return axios.get(localesFile)
}

function getConfig(configFile) {
    configFile = configFile || 'config/config.json'
    return axios.get(configFile).then(function(config) {
        return config.data;
    })
}

function getFile(path) {
    return axios.get(path)
}

export default {
    getConfig: getConfig,
    getLocales: getLocales,
    getPages: getPages,
    getFile: getFile,
}